import { DATE_FORMAT } from 'common/constants/constants';
import { StyledCell } from 'components/base/Table/Table.styles';
import moment from 'moment';

const TargetCell = ({ target }) => {
  const validDate = target && moment(target).isValid();
  return (
    <StyledCell>
      {validDate ? moment(target).format(DATE_FORMAT) : '-'}
    </StyledCell>
  );
};

export default TargetCell;
